import React, { useEffect, useState } from "react";
import { RenderForm } from "../../utils/formUtils";
import useForm from "../../hooks/useForm";
import { Stack } from "@mui/material";
import { FormButton } from "../../components/buttons/FormButton";
import { AutofillForm } from "../../utils/helpers";
import { useFirebase } from "../../hooks/firebase/useFirebase";
import { CONTACTS_REF } from "../../constants/api";
import { TEXT_TYPE } from "../../constants/webapp";
import {
  FormHandlerWrapper,
  FormWrapper,
} from "../../components/styled/StyledComponents";

export const ContactsForm = () => {
  const { form, onChange, updateFormValue, setForm } = useForm();
  const { loading, getDocData, data, updateData } = useFirebase();
  const [docRef, setDocRef] = useState();

  // get contact data
  useEffect(() => {
    getDocData(CONTACTS_REF);
  }, []);

  // set doc reference
  useEffect(() => {
    const docRef = data?.docRef;
    if (docRef) setDocRef(docRef);
  }, [data]);

  AutofillForm(data, setForm);

  const onSubmit = (e) => {
    e.preventDefault();
    if (docRef) updateData(docRef, form);
  };

  const fields = [
    {
      id: "phone",
      label: "Phone Number",
      props: { type: "tel" },
      type: TEXT_TYPE,
      required: true,
    },
  ];

  return (
    <form onSubmit={onSubmit}>
      <FormHandlerWrapper className="whiteBg radius6">
        <div>
          <Stack spacing={3}>
            <h3>Contacts</h3>
            <RenderForm {...{ form, onChange, fields, updateFormValue }} />
            <FormButton loading={loading}>Save</FormButton>
          </Stack>
        </div>
      </FormHandlerWrapper>
    </form>
  );
};
